import React, { useState } from "react";
import { useField } from "@2po/formalizr";
import { Select } from "@2po-dpam/components";
import * as style from "./style.module.scss";

import { useContentfulFormalizr } from "@hooks";
import { fillDynamicsForm } from "@utils/dynamics";
import { FormGroup, Label } from "reactstrap";
import { sortValueLabelArrayByLabel } from "@utils/formalizr";

type Props = {
    name: string;
};

const FormalizerDropdownField = ({ name }: Props) => {
    const { formName } = useContentfulFormalizr();
    const [field, meta, locale] = useField({ name });
    const [value, setValue] = useState("");
    const translatedOptions: Record<string, any> =
        meta?.widget?.options?.["i18n"] ?? {};

    const options = Object.entries(translatedOptions).map(([key, value]) => ({
        value: key,
        label: (value as Record<string, string>)[locale] ?? key,
    }));

    const handleChange = (value: string) => {
        fillDynamicsForm(formName, field.name, value);

        field.onChange({
            target: {
                value: value,
                name: field.name,
            },
        });

        setValue(value);
    };

    const sortedOptions = sortValueLabelArrayByLabel(
        options,
        meta?.widget?.options?.["sort"],
    );

    const showErrorMessage = () => meta.error && meta.touched;

    return (
        <FormGroup>
            <Label htmlFor={field.name}>{field.label[locale]}</Label>
            <Select
                id={field.name}
                items={sortedOptions}
                noBoldStyling
                onChange={handleChange}
                tabIndex={0}
                value={value}
            />
            {showErrorMessage() && <p className={style.error}>{meta.error}</p>}
        </FormGroup>
    );
};

export default FormalizerDropdownField;
